import React from 'react'
import IrregularInteraction from '../IrregularInteraction'
import ItemImage from '../ItemImage'
import image from '../../assets/images/item--rug@3x.png'

const path =
  'M0,133.86 L231.38,0 L411.07,103.74 L411.07,106.36 L179.69,240.22 L0,136.48 L0,133.86 Z'

const Rug = props => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 412 241"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Rug.propTypes = IrregularInteraction.propTypes

export default Rug



// WEBPACK FOOTER //
// ./src/components/items/Rug.js